var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ui buttons fluid",
      class: _vm.buttonsClasses,
      attrs: { "data-wd": "inSearchType" }
    },
    [
      _c(
        "button",
        {
          staticClass: "ui button",
          class: { active: _vm.type === "book" },
          on: {
            click: function($event) {
              return _vm.changeType("book")
            }
          }
        },
        [
          _c("i", { staticClass: "book icon" }),
          _vm._v("\n    " + _vm._s(_vm.$tc("words.book", 2)) + "\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "ui button",
          class: { active: _vm.type === "memo" },
          on: {
            click: function($event) {
              return _vm.changeType("memo")
            }
          }
        },
        [
          _c("i", { staticClass: "sticky note icon" }),
          _vm._v("\n    " + _vm._s(_vm.$tc("words.memo", 2)) + "\n  ")
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }